import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/image/close.png';
import _imports_1 from '../../assets/image/link_r_b.png';
const _withScopeId = n => (_pushScopeId("data-v-f06c8770"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tk-main-QEcode"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_3 = [_hoisted_2];
const _hoisted_4 = {
  class: "tk-exit-name"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tk-exit-title"
}, "选择聊天室", -1));
const _hoisted_6 = {
  class: "tk-exit-from"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "icon"
};
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  class: "name"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "more"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
})], -1));
import { roomList } from '@/utils/https/wechar';
import { onBeforeMount, reactive } from 'vue';

import { useRouter } from 'vue-router';
export default {
  __name: 'wecharList',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: []
    }
  },
  emits: ['selecRoom', 'update:show'],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const router = useRouter();

    // let list = reactive([
    //     // {name:'香港六合聊天室',id:'1',selectIcon:require('../../assets/image/major/provice/2028.png')},
    //     // {name:'新澳门六合聊天室',id:'2',selectIcon:require('../../assets/image/major/provice/2015.png')},
    //     // {name:'台湾六合聊天室',id:'3',selectIcon:require('../../assets/image/major/provice/2029.png')},
    //     // {name:'新加坡六合聊天室',id:'4',selectIcon:require('../../assets/image/major/provice/2019.png')},
    //     // {name:'澳门六合聊天室',id:'5',selectIcon:require('../../assets/image/major/provice/2015.png')},
    // ])

    let colse = () => {
      emits('update:show', false);
    };
    let overlayPop = () => {
      emits('update:show', false);
    };
    onBeforeMount(() => {
      // if(localStorage.getItem('room_info')==null){
      //     roomLists();
      // }else{
      //     let datas = JSON.parse(localStorage.getItem('room_info'));
      //     datas.forEach((item,index) => {
      //         switch (item.id) {
      //             case 1:
      //                list.push( {name:item.name,id:item.id,selectIcon:require('../../assets/image/major/provice/2028.png')})
      //                 break;
      //                 case 2:
      //                list.push( {name:item.name,id:item.id,selectIcon:require('../../assets/image/major/provice/2015.png')})
      //                 break;
      //                 case 3:
      //                list.push( {name:item.name,id:item.id,selectIcon:require('../../assets/image/major/provice/2029.png')})
      //                 break;
      //                 case 4:
      //                list.push( {name:item.name,id:item.id,selectIcon:require('../../assets/image/major/provice/2019.png')})
      //                 break;
      //                 case 5:
      //                 list.push( {name:item.name,id:item.id,selectIcon:require('../../assets/image/major/provice/2015.png')})
      //                 break;
      //             default:
      //                 break;
      //         }
      //     });
      // }
    });
    let roomLists = () => {
      roomList().then(res => {
        if (res == undefined) return false;
        let datas = res.data.data;
        datas.forEach((item, index) => {
          switch (item.id) {
            case 1:
              list.push({
                name: item.name,
                id: item.id,
                selectIcon: require('../../assets/image/major/provice/2028.png')
              });
              break;
            case 2:
              list.push({
                name: item.name,
                id: item.id,
                selectIcon: require('../../assets/image/major/provice/2015.png')
              });
              break;
            case 3:
              list.push({
                name: item.name,
                id: item.id,
                selectIcon: require('../../assets/image/major/provice/2029.png')
              });
              break;
            case 4:
              list.push({
                name: item.name,
                id: item.id,
                selectIcon: require('../../assets/image/major/provice/2019.png')
              });
              break;
            case 5:
              list.push({
                name: item.name,
                id: item.id,
                selectIcon: require('../../assets/image/major/provice/2015.png')
              });
              break;
            default:
              break;
          }
        });
        localStorage.setItem('room_info', JSON.stringify(datas));
      });
    };
    let selecRoom = item => {
      if (localStorage.getItem('usetInfo') == null) {
        router.push({
          path: '/login'
        });
      } else {
        emits('selecRoom', item);
      }
    };
    return (_ctx, _cache) => {
      const _component_van_overlay = _resolveComponent("van-overlay");
      return _openBlock(), _createBlock(_component_van_overlay, {
        show: __props.show,
        "z-index": "1000"
      }, {
        default: _withCtx(() => [__props.list.length != 0 ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "wrapper",
          onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => _unref(overlayPop) && _unref(overlayPop)(...args), ["stop"]))
        }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
          class: "colse",
          onClick: _cache[0] || (_cache[0] = (...args) => _unref(colse) && _unref(colse)(...args))
        }, _hoisted_3), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item, index) => {
          return _openBlock(), _createElementBlock("li", {
            key: index,
            onClick: $event => _unref(selecRoom)(item)
          }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("img", {
            src: item.selectIcon,
            alt: ""
          }, null, 8, _hoisted_9)]), _createElementVNode("div", _hoisted_10, _toDisplayString(item.name), 1), _hoisted_11], 8, _hoisted_7);
        }), 128))])])])])])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["show"]);
    };
  }
};